// Shopee Open API v2 order_status — ค่าเดียวกับ EShopeeOrderStatus ฝั่ง webhook
export const SHOPEE_STATUS_LABEL: Record<string, string> = {
  UNPAID: 'ยังไม่ได้ชำระเงิน',
  READY_TO_SHIP: 'รอจัดส่ง',
  PROCESSED: 'เตรียมจัดส่ง',
  SHIPPED: 'กำลังจัดส่ง',
  TO_CONFIRM_RECEIVE: 'รอยืนยันรับสินค้า',
  IN_CANCEL: 'กำลังยกเลิก',
  CANCELLED: 'ยกเลิก',
  TO_RETURN: 'รอคืนสินค้า',
  COMPLETED: 'เสร็จสิ้น',
  INVOICE_PENDING: 'รอออกใบกำกับภาษี',
}

export const getStatusLabel = (status?: string): string =>
  SHOPEE_STATUS_LABEL[status ?? ''] ?? status ?? '-'

// สถานะที่ถือว่าขายสำเร็จ — ตรงกับ SUCCESS_STATUSES ฝั่ง apps/shopee (successTotal)
export const SUCCESS_STATUSES = ['COMPLETED']
